import PublicLayout from '../../../components/public/PublicLayout';
import Hero from '../../../components/public/Hero';
import { NoRealData } from '@/components/shared';

export default function ParksPage(){return <PublicLayout><Hero eyebrow="FLORAIQ" title="Parques de Goiânia" subtitle="Descubra, explore e valorize os parques que tornam nossa cidade mais verde." description="Natureza, lazer, bem-estar e educação ambiental em espaços que conectam pessoas." image="/assets/hero-parks.jpg"/>
 <div className="page-pad">
  <NoRealData variant="page" title="Parques e áreas verdes" description="O cadastro público de parques e áreas verdes (localização, infraestrutura e estado de conservação) ainda não está disponível." icon="ri-landscape-line"/>
 </div></PublicLayout>}
